export default __webpack_public_path__ + "static/rsz_mirek_p-d2257479b32f43e8729b79da307d0df3.jpg";